import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function TicketDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Ticket")}
      endpoint={`/tickets/${props.match.params.id}/`}
      successRoute={reverse("ticketList")}
      errorRoute={reverse("ticketDetail", { id: props.match.params.id })}
    />
  )
}

TicketDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
